import { useCallback, useEffect, useState } from 'react';
import { api, type Block } from '../api/client.ts';

/** The grid rolls: a completed block appears and the oldest drops off (§10.2). */
const REFRESH_MS = 30_000;

/**
 * The block list for a stream.
 *
 * Held above the grid because "cut this" has to turn a moment on the clock into
 * the block that holds it, and that question is asked from the player and the
 * live button, not from the grid.
 */
export function useBlocks(streamId: number | null): {
  blocks: Block[] | null;
  failed: boolean;
  reload: () => void;
} {
  const [blocks, setBlocks] = useState<Block[] | null>(null);
  const [failed, setFailed] = useState(false);

  const reload = useCallback((): void => {
    if (streamId === null) return;
    void api.blocks(streamId)
      .then((next) => { setBlocks(next); setFailed(false); })
      .catch(() => setFailed(true));
  }, [streamId]);

  useEffect(() => {
    setBlocks(null);
    reload();
    const timer = setInterval(reload, REFRESH_MS);
    return () => clearInterval(timer);
  }, [reload]);

  return { blocks, failed, reload };
}
